/**
 * MSW Overrides: Availability Not Found scenario
 *
 * The POST confirmation endpoint returns a fresh TripSearchResponse whose trip IDs
 * do NOT match the ones the user selected from the cached browse (GET) response.
 *
 * This simulates stale cached data: the selected trip was valid when browsed but is
 * no longer present once the real-time confirmation check runs.
 * `useBookTripSelection` detects the mismatch and calls `handleUnavailable()`.
 *
 * Enable by setting ENABLE_MSW=true and NUXT_PUBLIC_MSW_OVERRIDES_AVAILABILITY_NOT_FOUND=true
 * in your .env, then restart the dev server.
 */

import type { HttpHandler } from 'msw';
import { http, HttpResponse } from 'msw';
import { BFF_ENDPOINTS, createMockTripSearchResponse, toMSWPattern } from '@cvo/domain';

export function createAvailabilityNotFoundOverrides(baseUrl: string): HttpHandler[] {
  const sanitizedBaseUrl = baseUrl.replace(/\/$/, '');

  return [
    http.post(
      `${sanitizedBaseUrl}/${toMSWPattern(BFF_ENDPOINTS.TRIP_SEARCH)}`,
      () => {
        // Return different trip IDs so the previously selected trip is not found
        // in the confirmed results, triggering the "unavailable" handling in useBookTripSelection.
        const response = createMockTripSearchResponse({
          outbound: [],
          inbound: [],
        });
        return HttpResponse.json(response);
      },
    ),
  ];
}
